import EventMonthList from './EventMonthList';
import DateFormatter from '../../date/EventListingDateFormatter';

class EventDayList extends EventMonthList {

  constructor() {
    super();
    this.resultsFormatter = DateFormatter.standardDate;
    this.dayFormatter = DateFormatter.weekdayLabel;
    this.isSingleDayView = true;
  }

}

export default EventDayList;
